import { useSearch } from '@tanstack/react-router';
import QRApproveAccess from '@/components/access/QRApproveAccess';
import { DefaultActions, type DefaultAction } from '@/utils/access/grantHelpers';

const ApproveComponent = () => {
	const { token: approveToken, deny_token: denyToken, action } = useSearch({ from: '/access/$token/approve' });
	return <QRApproveAccess approveToken={approveToken} denyToken={denyToken} defaultAction={action} />;
};

export const Route = createFileRoute({
	component: ApproveComponent,
	validateSearch: (search) => ({
		token: search.token as string,
		deny_token: search.deny_token as string | undefined,
		action: (search.action as DefaultAction | undefined) ?? DefaultActions.Approve,
	}),
});
